import { Check, ArrowRight } from "lucide-react";
import { PRICING } from "@/lib/data";

export default function Pricing() {
  return (
    <section id="pricing" data-testid="pricing-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="eyebrow">Pricing</span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 text-[#041047] tracking-tight leading-[1.1]">
            Premium marketing. <em className="italic font-medium">Fair pricing.</em>
          </h2>
          <p className="mt-5 text-[#475569] text-lg">
            Transparent monthly retainers. Cancel anytime after 90 days. No hidden fees.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {PRICING.map((p, i) => (
            <div
              key={p.name}
              data-testid={`pricing-card-${i}`}
              className={`relative p-8 md:p-10 border transition-all duration-300 flex flex-col ${
                p.highlighted
                  ? "bg-[#041047] text-white border-[#041047] md:-translate-y-4 shadow-[0_30px_60px_-30px_rgba(4,16,71,0.6)]"
                  : "bg-white border-[#041047]/12 hover:border-[#D4AF37]/60 hover:-translate-y-1"
              }`}
            >
              {p.highlighted && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#D4AF37] text-[#1a1200] text-[0.65rem] tracking-[0.2em] font-bold uppercase px-3 py-1">
                  Most Popular
                </span>
              )}
              <h3 className={`font-display text-2xl ${p.highlighted ? "text-white" : "text-[#041047]"}`}>
                {p.name}
              </h3>
              <p className={`text-sm mt-1 ${p.highlighted ? "text-white/70" : "text-[#475569]"}`}>
                {p.tagline}
              </p>

              <div className="mt-6 mb-7">
                <div className={`font-display text-5xl ${p.highlighted ? "text-white" : "text-[#041047]"}`}>
                  {p.price}
                </div>
                <div className={`text-sm mt-1 ${p.highlighted ? "text-white/60" : "text-[#475569]"}`}>
                  {p.period}
                </div>
              </div>

              <ul className="flex-1 space-y-3 mb-8">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-3">
                    <Check
                      className={`w-4 h-4 mt-1 flex-shrink-0 ${
                        p.highlighted ? "text-[#D4AF37]" : "text-[#041047]"
                      }`}
                    />
                    <span
                      className={`text-[0.95rem] leading-relaxed ${
                        p.highlighted ? "text-white/85" : "text-[#475569]"
                      }`}
                    >
                      {f}
                    </span>
                  </li>
                ))}
              </ul>

              <a
                href="#contact"
                data-testid={`pricing-cta-${i}`}
                className={
                  p.highlighted
                    ? "btn-gold w-full"
                    : "btn-primary w-full"
                }
              >
                Start Now <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
